/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconDiamond: {
  name: 'diamond';
  data: string;
} = {
  name: 'diamond',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M511.644 113.308H100.067L13.035 230.546l293.93 322.113 293.93-322.113-89.251-117.238zM306.966 549.229 191.63 232.705l115.335-117.728L422.3 232.705 306.966 549.229zM182.769 226.46 94.024 109.329M429.109 226.46l87.349-117.131"/><path d="M182.769 232.493H429.10900000000004V243.493H182.769z"/></svg>`,
};
